import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { hasPermission } from '@helios/authz';
import { Link2 } from 'lucide-react';
import { useAuth } from '@/features/auth/authContext';
import { UNIFIED_CRM_READ } from './unified-crm.hooks';

/** Resolve original IDs on the server; never infer a person or organization from a name. */
export function CanonicalProfileLink({
  objectType,
  objectId,
  children,
  className = '',
}: {
  objectType: string;
  objectId: string;
  children?: ReactNode;
  className?: string;
}) {
  const auth = useAuth();
  if (!hasPermission(auth.permissions, UNIFIED_CRM_READ)) return null;
  const params = new URLSearchParams({ objectType, objectId });
  return (
    <Link
      to={`/crm/resolve?${params}`}
      className={`text-context-primary inline-flex items-center gap-1 text-xs hover:underline ${className}`}
    >
      <Link2 className="h-3.5 w-3.5" aria-hidden="true" />
      {children ?? 'Relationship profile'}
    </Link>
  );
}
